import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChargerStatusResponse } from '../../model/reports';

export type ChargerStatusState = {
  data: ChargerStatusResponse | null;
  loading: boolean;
  error: string | null;
  toggleValue: number;
};

const initialState: ChargerStatusState = {
  data: null,
  loading: false,
  error: null,
  toggleValue: 0,
};

const slice = createSlice({
  name: 'chargerStatus',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess: (state, action: PayloadAction<ChargerStatusResponse>) => {
      state.loading = false;
      state.data = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
    fetchFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
  },
});

export const chargerStatus = slice.reducer;
export const { fetchStart, fetchSuccess, fetchFailed } = slice.actions;
